import React from 'react';

function FeedBackBtn() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18.843'
      height='17.901'
      viewBox='0 0 18.843 17.901'
    >
      <g fill='#fff' transform='translate(.001 .915)'>
        <path
          d='M359.657 1.107l-1.884-1.884a.471.471 0 00-.666 0l-5.653 5.653a.47.47 0 00-.138.333v1.884a.471.471 0 00.471.471h1.884a.47.47 0 00.329-.138l5.653-5.653a.471.471 0 000-.666zm-6.181 5.515h-1.218V5.4L357.44.222l1.218 1.218zm0 0'
          data-name='Path 6202'
          transform='translate(-340.953)'
        ></path>
        <path
          d='M17.429 66.734a.471.471 0 00-.471.471v6.6a1.415 1.415 0 01-1.413 1.413h-4.711a.468.468 0 00-.283.094l-3.014 2.257v-1.884a.471.471 0 00-.471-.471H2.355A1.415 1.415 0 01.942 73.8v-8.48a1.415 1.415 0 011.413-1.413h8.479a.471.471 0 100-.942H2.355A2.358 2.358 0 000 65.321V73.8a2.358 2.358 0 002.355 2.355h4.24v2.355a.471.471 0 00.754.377l3.643-2.732h4.553A2.358 2.358 0 0017.9 73.8v-6.595a.471.471 0 00-.471-.471zm0 0'
          data-name='Path 6203'
          transform='translate(0 -61.996)'
        ></path>
        <path
          d='M100.994 158.773h-4.711a.471.471 0 100 .942h4.711a.471.471 0 100-.942zm0 0'
          data-name='Path 6204'
          transform='translate(-92.987 -154.977)'
        ></path>
        <path
          d='M96.283 255.528h4.711a.471.471 0 100-.942h-4.711a.471.471 0 100 .942zm0 0'
          data-name='Path 6205'
          transform='translate(-92.987 -247.963)'
        ></path>
        <path
          d='M96.283 351.34h11.306a.471.471 0 000-.942H96.283a.471.471 0 100 .942zm0 0'
          data-name='Path 6206'
          transform='translate(-92.987 -340.95)'
        ></path>
      </g>
    </svg>
  );
}

export default FeedBackBtn;
